// src/lib/productProgress.js
//
// Same-browser-session convenience: remembers an email the person already
// typed earlier in this visit, so a later save/sign-in step can prefill it
// instead of asking twice. That's the only thing this file does now.
//
// FORMERLY also tracked "did this person already do the other free product
// earlier in this browsing session" (markProductDone/isProductDone,
// sessionStorage-backed) — removed. That signal fired the moment a result
// page was merely viewed, regardless of whether the person ever saved or
// signed in, which meant an anonymous visitor who did both free products
// in one tab without saving either got shown ResultCTA.js's "both done"
// advisor-only card, with no way to save the result they were currently
// looking at. If someone hasn't created an account, there's nothing to
// meaningfully acknowledge as "done" — they can't return to an unsaved
// result in this tab anyway. "Both done" is now solely the real,
// authenticated, DB-backed check (useProductMode.js), never a same-visit
// guess. If a future need for a lighter same-session signal comes back,
// re-derive it deliberately rather than reviving these two functions —
// this exact shape is what caused the bug.

const KEYS = {
  knownEmail: 'hs_known_email',
}

export function saveKnownEmail(email) {
  if (email) sessionStorage.setItem(KEYS.knownEmail, email)
}

export function getKnownEmail() {
  return sessionStorage.getItem(KEYS.knownEmail) || ''
}